import React from "react";
import { useLocation } from "react-router-dom";

import styles from "./site-toolbar.module.scss";

export default function SiteToolbar() {
  const location = useLocation();

  const isLinkActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <section className={styles.toolbar}>
      <div className={styles.logo}>
        <a href="/">Run for Their Lives</a>
      </div>
      <nav>
        <a
          href="/locations"
          className={isLinkActive("/locations") ? "selected" : ""}
        >
          Locations
        </a>
        <a href="/outfit" className={isLinkActive("/shirts") ? "selected" : ""}>
          Outfit
        </a>
        <a href="/lead" className={isLinkActive("/lead") ? "selected" : ""}>
          Lead
        </a>
        <a href="/press" className={isLinkActive("/press") ? "selected" : ""}>
          Press
        </a>
        <a href="/" className={styles.toolbarJoin}>
          Join
        </a>
      </nav>
    </section>
  );
}
